import useGet from '../../../hooks/useGet';
import axios from 'axios';
import { saveFile } from 'src/utils/pdfUtil';
const withIsNmResident = (url, isNmResident) => {
    if (isNmResident === undefined) {
        return url;
    }
    return `${url}?${new URLSearchParams({ 'is-nm-resident': String(isNmResident) })}`;
};
const normalizeMedicalQuestions = (data) => {
    data.medicalQuestions.forEach(question => {
        question.questionCode = question.medicalFactorQuestionCode;
    });
};
export const GetInitialInformation = (isNmResident) => {
    const result = useGet({
        url: withIsNmResident('/eoi-service/questions/initial-information', isNmResident),
    });
    if (result?.data) {
        normalizeMedicalQuestions(result.data);
    }
    return result;
};
export const GetCustomContent = () => {
    return useGet({ url: `/eoi-service/config/custom-content` });
};
export const GetCustomerConfig = () => {
    return useGet({ url: '/eoi-service/config' });
};
export const GetLegalText = (isNmResident) => {
    return useGet({ url: withIsNmResident('/eoi-service/questions/legal-conditions', isNmResident) });
};
export const FetchInitialInformation = async (authHeader, isNmResident) => {
    const response = await axios.get(withIsNmResident('/eoi-service/questions/initial-information', isNmResident), { headers: { Authorization: authHeader } });
    normalizeMedicalQuestions(response.data);
    return response.data;
};
export const FetchLegalText = async (authHeader, isNmResident) => {
    const response = await axios.get(withIsNmResident('/eoi-service/questions/legal-conditions', isNmResident), { headers: { Authorization: authHeader } });
    return response.data;
};
export const GetPrePopData = async (data, authHeader) => {
    const response = await axios.post(`/eoi-service/prepop`, data, {
        headers: { Authorization: authHeader },
    });
    return response.data;
};
export const GetInterviewData = () => {
    return useGet({ url: `/eoi-service/save-for-later` });
};
export const SaveInterviewData = async (interviewData, authHeader, language) => {
    await axios.post(`/eoi-service/save-for-later?lang=${language}`, interviewData, {
        headers: { Authorization: authHeader },
    });
};
export const DeleteInterviewData = async (authHeader) => {
    await axios.delete(`/eoi-service/save-for-later`, { headers: { Authorization: authHeader } });
};
export const downloadEsignAuthForm = async (authHeader, language, fileName, errorMessage, setDownloadError, employeeResidenceState) => {
    try {
        const response = await axios.get(`/eoi-service/document/esign-auth?lang=${language}&employee-residence-state=${employeeResidenceState.toUpperCase()}`, {
            responseType: 'blob',
            headers: { Authorization: authHeader },
        });
        const filename = `${fileName}.pdf`;
        saveFile(response, filename, response.headers['content-disposition']);
        setDownloadError(undefined);
    }
    catch (error) {
        setDownloadError(errorMessage);
    }
};
export const downloadNoticeOfInformationPractices = async (authHeader, language, fileName, errorMessage, setDownloadError, employeeResidenceState) => {
    try {
        const response = await axios.get(`/eoi-service/document/notice-of-information-practices?lang=${language}&employee-residence-state=${employeeResidenceState.toUpperCase()}`, {
            responseType: 'blob',
            headers: { Authorization: authHeader },
        });
        const filename = `${fileName}.pdf`;
        saveFile(response, filename, response.headers['content-disposition']);
        setDownloadError(undefined);
    }
    catch (error) {
        setDownloadError(errorMessage);
    }
};
// TODO: language will eventually be used when we have to support a spanish version of the PDF.
export const downloadConfirmationPdf = async (authHeader, language, submission, applicationId, setDownloadError, errorMessage) => {
    try {
        const response = await axios.post(`/eoi-service/document/confirmation?lang=${language}`, submission, {
            responseType: 'blob',
            headers: { Authorization: authHeader },
        });
        const filename = `${applicationId}.pdf`;
        saveFile(response, filename);
    }
    catch (error) {
        setDownloadError(errorMessage);
    }
};
export const requestReflexiveQuestions = (medicalInformationAnswers, authHeader, isNmResident) => {
    return axios.post(withIsNmResident('/eoi-service/questions/reflexive-questions', isNmResident), medicalInformationAnswers, {
        headers: { Authorization: authHeader },
    });
};
export const SubmitApplication = (submission, authHeader, language) => {
    return axios.post(`/eoi-service/questions/submit?lang=${language}`, submission, {
        headers: { Authorization: authHeader },
    });
};
export const CheckDuplicateApplication = (duplicateApplicationResource, authHeader) => {
    return axios.post('/eoi-service/prepop/duplicate-application', duplicateApplicationResource, {
        headers: { Authorization: authHeader },
    });
};
